import React, { useEffect, useState } from 'react'

import Cross from 'components/common/Cross'
import Modal from 'components/common/Modal'
import Cookie from 'helpers/cookie'
import {
    greetingEventEmitter,
    greetingKeys,
    vibeKeys,
    vibeEventEmitter,
} from 'helpers/events'
import { isMobileOrIPad } from 'utils/device'

import { Content, Header, Heading, Body, Footer, Button } from './styles'

const classDuration = 130 // mins
const COOKIE = 'FEATURE_AVAILABILITY'
const COOKIE_EXPIRY = classDuration / 1440 // days

const FeatureAvailability = ({ isTeacher }) => {
    const [showModal, setShowModal] = useState(false)

    const onClose = () => {
        setShowModal(false)
        Cookie.set(COOKIE, 'true', {
            expires: COOKIE_EXPIRY,
        })
    }

    const crossProps = {
        onClick: onClose,
        color: '#E87D7C',
    }

    useEffect(() => {
        const handleShowModal = () => {
            const hideModal = Cookie.get(COOKIE) === 'true'

            !hideModal && setShowModal(true)
        }

        greetingEventEmitter.addListener(greetingKeys.TOMATO, handleShowModal)

        vibeEventEmitter.addListener(vibeKeys.VIBE, handleShowModal)

        return () => {
            vibeEventEmitter.removeListener(vibeKeys.VIBE, handleShowModal)
            greetingEventEmitter.removeListener(
                greetingKeys.TOMATO,
                handleShowModal
            )
        }
    }, [])

    console.count('FeatureAvailability Component')

    const modalProps = {
        open: showModal,
        onClose,
        closeOnOutsideClick: false,
        displayCloseBtn: false,
    }

    if (!isMobileOrIPad) return null

    const content = `we can see that your ${
        isTeacher ? 'students' : 'friends'
    } are vibing with each other and
    having food fights. move to your laptop to join them!`

    return (
        <Modal {...modalProps}>
            <Content>
                <Header>
                    <Heading>oh no</Heading>
                    <Cross {...crossProps} />
                </Header>
                <Body>{content}</Body>
                <Footer>
                    <Button onClick={onClose}>ok</Button>
                </Footer>
            </Content>
        </Modal>
    )
}

export default FeatureAvailability
